// extracted by mini-css-extract-plugin
export default {"pwaButton":"InstallPWAButton_pwaButton__8XdzI","hidden":"InstallPWAButton_hidden__gM4cE","icon":"InstallPWAButton_icon__SBeha","SmallButton":"InstallPWAButton_SmallButton__qSrg-"};